export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      Result: 'success',
      CmsMastaInfo: [
        {
          CmsMastaId: 2,
          CmsName: 'バス予約管理CMS',
          CmsCode: 'cms-xxxxx-xxxxx-xxxxx',
          Url: 'https://xxx.xxx.xxx',
          Status: 1
        },
        {
          CmsMastaId: 1,
          CmsName: 'レストラン予約CMS',
          CmsCode: 'cms-xxxxx-xxxxx-xxxxx',
          Url: 'https://xxx.xxx.xxx',
          Status: 1
        }
      ]
    }
  }
}